import { createModel } from '@/store/tools';

const model = {
    namespace: 'platformsubsidy',
    build: (T, A, S, R) => ({
        actiontypes: {
            'getCancelOrderList': T('getCancelOrderList'),
        },
        actions: {
            'getCancelOrderList': A('getCancelOrderList'),
        },
        sagas: {
            'getCancelOrderList': S('getCancelOrderList', '/?cmd=com.xqxc.api.pig.mis.settle.SettleReceiptApiMisService.platformList'),
        },
        reducers: {
            'cancelOrderList': R('getCancelOrderList', { dataList: [], pageNum: 1, pageSize: 25, resultTotal: 0 }),
        }
    })
};
export default createModel(model);